// import { useQuery } from '@tanstack/react-query';
// import { tourServices } from '../services/tour.service';

// export const useTours = ({
//   page,
//   limit,
//   sellerId,
//   destination,
//   tourType,
//   category,
//   approvalStatus,
//   isActive,
//   minPrice,
//   maxPrice,
//   minDuration,
//   maxDuration,
//   search,
//   sortBy,
//   sortOrder,
// }) => {
//   return useQuery({
//     queryKey: [
//       'tours',
//       {
//         page,
//         limit,
//         sellerId,
//         destination,
//         tourType,
//         category,
//         approvalStatus,
//         isActive,
//         minPrice,
//         maxPrice,
//         minDuration,
//         maxDuration,
//         search,
//         sortBy,
//         sortOrder,
//       },
//     ],
//     queryFn: () =>
//       tourServices.getTours({
//         page,
//         limit,
//         sellerId,
//         destination,
//         tourType,
//         category,
//         approvalStatus,
//         isActive,
//         minPrice,
//         maxPrice,
//         minDuration,
//         maxDuration,
//         search,
//         sortBy,
//         sortOrder,
//       }),
//     staleTime: 5 * 60 * 1000, // 5 minutes
//     gcTime: 10 * 60 * 1000, // 10 minutes
//     keepPreviousData: true,
//   });
// };


import { useQuery } from '@tanstack/react-query';
import { tourServices } from '../services/tour.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all tours
 */
export const useTours = ({
  page,
  limit,
  sellerId,
  destination,
  tourType,
  category,
  approvalStatus,
  isActive,
  minPrice,
  maxPrice,
  minDuration,
  maxDuration,
  search,
  sortBy,
  sortOrder,
}) => {
  return useQuery({
    queryKey: [
      'tours',
      {
        page,
        limit,
        sellerId,
        destination,
        tourType,
        category,
        approvalStatus,
        isActive,
        minPrice,
        maxPrice,
        minDuration,
        maxDuration,
        search,
        sortBy,
        sortOrder,
      },
    ],

    queryFn: async () => {
      try {
        return await tourServices.getTours({
          page,
          limit,
          sellerId,
          destination,
          tourType,
          category,
          approvalStatus,
          isActive,
          minPrice,
          maxPrice,
          minDuration,
          maxDuration,
          search,
          sortBy,
          sortOrder,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};